/**
 * UI-3.5: Entity View Loading Skeleton
 *
 * Matches actual 4-zone investigation layout:
 *   Header → SituationBanner → RecentActivity → ImpactSignals → RecommendedActions
 */

export function EntityViewSkeleton() {
  return (
    <div className="h-full flex flex-col bg-slate-900 animate-pulse" aria-busy="true" aria-label="Loading investigation">
      {/* ── Header skeleton (matches sticky nav bar) ──────────────────── */}
      <div className="sticky top-0 z-20 bg-slate-800/95 border-b border-slate-700 px-6 py-3">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-slate-700" />
          <div className="h-4 bg-slate-700 rounded w-32" />
          <div className="h-3 bg-slate-700 rounded w-20" />
        </div>
      </div>

      {/* ── 4 Investigation Zones ─────────────────────────────────────── */}
      <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4 max-w-3xl mx-auto w-full">
        {/* Zone 1: Situation Banner placeholder */}
        <div className="bg-slate-800 border border-slate-700 rounded-lg px-5 py-4 space-y-2">
          <div className="h-4 bg-slate-700 rounded w-3/4" />
          <div className="h-3 bg-slate-700 rounded w-1/2" />
        </div>

        {/* Zone 2: Recent Activity placeholder */}
        <div className="bg-slate-800 border border-slate-700 rounded-lg overflow-hidden">
          <div className="px-5 py-3 border-b border-slate-700/50">
            <div className="h-3 bg-slate-700 rounded w-24" />
          </div>
          <div className="divide-y divide-slate-700/30">
            {Array.from({ length: 5 }, (_, i) => (
              <div key={i} className="px-5 py-2.5 flex items-center gap-3">
                <div className="w-4 h-4 rounded bg-slate-700 flex-shrink-0" />
                <div className="flex-1 space-y-1">
                  <div className="h-3 bg-slate-700 rounded w-2/3" />
                  <div className="h-2 bg-slate-700 rounded w-1/3" />
                </div>
                <div className="h-2 bg-slate-700 rounded w-12 flex-shrink-0" />
              </div>
            ))}
          </div>
        </div>

        {/* Zone 3: Impact Signals placeholder */}
        <div className="bg-slate-800 border border-slate-700 rounded-lg overflow-hidden">
          <div className="px-5 py-3 border-b border-slate-700/50">
            <div className="h-3 bg-slate-700 rounded w-28" />
          </div>
          <div className="p-4 space-y-2">
            {Array.from({ length: 2 }, (_, i) => (
              <div key={i} className="flex items-center gap-3 px-3 py-2 bg-slate-700/20 rounded-lg">
                <div className="w-2 h-2 rounded-full bg-slate-700" />
                <div className="h-3 bg-slate-700 rounded w-40" />
              </div>
            ))}
          </div>
        </div>

        {/* Zone 4: Recommended Actions placeholder */}
        <div className="bg-slate-800 border border-slate-700 rounded-lg overflow-hidden">
          <div className="px-5 py-3 border-b border-slate-700/50">
            <div className="h-3 bg-slate-700 rounded w-36" />
          </div>
          <div className="p-4 space-y-2">
            <div className="h-11 bg-slate-700 rounded-lg w-full" />
            <div className="h-11 bg-slate-700/60 rounded-lg w-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
